<template>
  <div id="hj-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="container">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/pc/mall' }">商城首页</el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.query.from === 'hot'" :to="{ path: '/pc/mall/hotProducts' }">精品推荐</el-breadcrumb-item>
          <el-breadcrumb-item v-if="category.id" :to="{ path: `/pc/mall/category/${category.id}/${category.name}` }">{{ category.name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ product.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- 商品详情 -->
    <div class="product-detail-section">
      <div class="container">
        <div class="product-main">
          <!-- 商品信息 -->
          <div class="product-info-container">
            <div class="product-info-left">
              <!-- 左侧图片 -->
              <div class="product-images">
                <div class="main-image">
                  <img :src="currentImage" :alt="product.name" />
                </div>
                <div class="thumb-images">
                  <div v-for="(image, index) in product.imgList" :key="index" :class="['thumb-item', currentImageIndex === index ? 'active' : '']" @click="selectImage(index)">
                    <img :src="image" :alt="product.name" />
                  </div>
                </div>
              </div>
              <!-- 右侧信息 -->
              <div class="product-info">
                <h1 style="font-size: 24px; font-weight: bold; text-align: left">{{ product.name }}</h1>

                <div class="product-price-section">
                  <div class="current-price">¥{{ product.retailPrice }}</div>
                  <div class="original-price">¥{{ product.retailPrice * 5 }}</div>
                  <div class="discount-tag">限时2折</div>
                </div>

                <div class="product-rating">
                  <span class="rating-stars">
                    <i v-for="n in 5" :key="n" :class="n <= 5 ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                  </span>
                  <span class="rating-text">商品评分</span>
                  <span class="sales-count">已售{{ product.stockNum + 100 }}</span>
                </div>
                <div class="product-specs">
                  <div class="spec-row">
                    <span class="spec-label"> 库存 </span>
                    <span class="spec-value">0 件</span>
                  </div>
                  <div class="spec-row">
                    <span class="spec-label">处方类型</span>
                    <span class="spec-value">{{ product.hashMap && product.hashMap['处方类型'] ? product.hashMap['处方类型'] : '非处方药' }}</span>
                  </div>
                  <div class="spec-row">
                    <span class="spec-label"> 配送时间 </span>
                    <span class="spec-value">{{ product.deliveryTime }}</span>
                  </div>
                  <div class="spec-row">
                    <span class="spec-label">购买数量</span>
                    <div class="quantity-control">
                      <el-button size="mini" @click="decreaseQuantity">-</el-button>
                      <el-input v-model="quantity" size="mini" style="width: 60px; text-align: center"></el-input>
                      <el-button size="mini" @click="increaseQuantity">+</el-button>
                    </div>
                  </div>
                </div>

                <div class="action-buttons">
                  <el-button type="danger" plain size="large" @click="addToCart">已售罄</el-button>
                  <el-button size="large" @click="addToast"><i class="el-icon-bell" style="margin-right: 5px"></i>到货通知</el-button>
                </div>

                <div class="service-info">
                  <div class="service-item">
                    <i class="el-icon-truck"></i>
                    <span>满足条件，免费包邮</span>
                  </div>
                  <div class="service-item">
                    <i class="el-icon-refresh"></i>
                    <span>正品保证，假一赔十</span>
                  </div>
                  <div class="service-item">
                    <i class="el-icon-phone"></i>
                    <span>售后无忧，服务保障</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 商品详情标签 -->
            <div class="product-detail-tabs">
              <div class="tab-headers">
                <div :class="['tab-header', activeTab === 'detail' ? 'active' : '']" @click="activeTab = 'detail'">商品详情</div>
                <!-- 器械商品显示资质 -->
                <div :class="['tab-header', activeTab === 'zizhi' ? 'active' : '']" @click="activeTab = 'zizhi'">资质信息</div>
                <div :class="['tab-header', activeTab === 'reviews' ? 'active' : '']" @click="activeTab = 'reviews'">全部评论</div>
              </div>

              <div class="tab-content">
                <!-- 商品详情 -->
                <div v-if="activeTab === 'detail'" class="detail-content">
                  <div v-if="product.combo">
                    <template v-if="product.imgList && product.imgList.length > 1">
                      <img v-for="(image, index) in product.imgList.slice(1)" :key="index" :src="image" :alt="product.name" />
                    </template>
                    <template v-else>
                      <div class="no-detail">
                        <img :src="require('@/assets/img/mall/no-order.png')" alt="暂无详情" style="width: 200px; height: 200px" />
                        <span style="font-size: 16px; color: #999; margin-top: 20px">暂无商品详情</span>
                      </div>
                    </template>
                  </div>
                  <div v-else>
                    <div class="product-detail-info">
                      <div class="info-card">
                        <h3 class="card-title">商品说明书</h3>
                        <div class="info-list">
                          <div class="info-item">
                            <span class="label">通用名</span>
                            <span class="content">{{ product.generalName || '-' }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">处方类型</span>
                            <span class="content">{{ product.recipeType || '-' }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">批准文号</span>
                            <span class="content">{{ product.serialNum || '-' }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">商品条形码</span>
                            <span class="content">{{ product.barCode || '-' }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">生产厂商</span>
                            <span class="content">{{ product.merchant || '-' }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">商品类别</span>
                            <span class="content">{{ product.productType || '-' }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">商品单位</span>
                            <span class="content">{{ product.productUnit || '-' }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">规格</span>
                            <span class="content">{{ product.specification || '-' }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">配送时间</span>
                            <span class="content">{{ product.deliveryTime || '-' }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="info-card" v-if="product.extraMap && Object.keys(product.extraMap).length > 0">
                        <h3 class="card-title">其他信息</h3>
                        <div class="info-list">
                          <div class="info-item" v-if="product.extraMap['品牌']">
                            <span class="label">品牌</span>
                            <span class="content">{{ product.extraMap['品牌'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['成份']">
                            <span class="label">成份</span>
                            <span class="content">{{ product.extraMap['成份'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['功能主治']">
                            <span class="label">功能主治</span>
                            <span class="content">{{ product.extraMap['功能主治'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['注意事项']">
                            <span class="label">注意事项</span>
                            <span class="content">{{ product.extraMap['注意事项'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['用法用量']">
                            <span class="label">用法用量</span>
                            <span class="content">{{ product.extraMap['用法用量'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['不良反应']">
                            <span class="label">不良反应</span>
                            <span class="content">{{ product.extraMap['不良反应'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['药物相互作用']">
                            <span class="label">药物相互作用</span>
                            <span class="content">{{ product.extraMap['药物相互作用'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['包装']">
                            <span class="label">包装</span>
                            <span class="content">{{ product.extraMap['包装'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['有效期']">
                            <span class="label">有效期</span>
                            <span class="content">{{ product.extraMap['有效期'] }}</span>
                          </div>
                          <div class="info-item" v-if="product.extraMap['产地类型']">
                            <span class="label">产地类型</span>
                            <span class="content">{{ product.extraMap['产地类型'] }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 资质信息 -->
                <div v-if="activeTab === 'zizhi'" class="detail-content">
                  <div v-if="product.medicalImageList">
                    <img v-for="(image, index) in product.medicalImageList" :key="index" :src="image" :alt="product.name" />
                  </div>
                  <div v-else>
                    <img :src="require('@/assets/img/mall/no-order.png')" alt="暂无资质信息" style="width: 200px; height: 200px" />
                    <span style="font-size: 16px; color: #999; margin-top: 20px">暂无资质信息</span>
                  </div>
                </div>
                <!-- 全部评论 -->
                <div v-if="activeTab === 'reviews'" class="reviews-content">
                  <img :src="require('@/assets/img/mall/no-order.png')" alt="暂无评论" style="width: 200px; height: 200px" />
                  <span style="font-size: 16px; color: #999; margin-top: 20px">暂无评论</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 店铺信息 -->
          <div class="product-info-right">
            <div class="shop-info">
              <div class="shop-header">
                <img :src="shopInfo.logo" :alt="shopInfo.name" class="shop-logo" />
                <div class="shop-details">
                  <h3>{{ shopInfo.name }}</h3>
                  <div class="shop-stats">
                    <span style="display: flex; justify-content: flex-start; align-items: center"
                      >店铺资质:
                      <img :src="require('@/assets/img/mall/dianpuzizhi.png')" alt="店铺资质" style="margin-left: 6px; width: 14px; height: 16px; margin-right: 10px; cursor: pointer" @click="goToShopVerify" />
                    </span>
                  </div>
                  <div class="shop-stats">
                    <span>宝贝数量: {{ shopInfo.productCount }}</span>
                  </div>
                  <div class="shop-stats">
                    <span>关注人数: {{ shopInfo.productCount + 1235 }}</span>
                  </div>
                  <div class="shop-stats shop-rating">
                    <span
                      >店铺评分：<span class="rating-stars">
                        <i v-for="n in 5" :key="n" :class="n <= shopInfo.rating ? 'el-icon-star-on' : 'el-icon-star-off'"></i> </span
                    ></span>
                  </div>
                </div>
              </div>

              <div class="shop-actions">
                <el-button type="primary" plain @click="goToShop"><i class="el-icon-s-shop"></i>进店逛逛</el-button>
                <el-button type="primary"><i class="el-icon-star-on"></i>收藏店铺</el-button>
              </div>
            </div>

            <!-- 店铺推荐 -->
            <div class="shop-info shop-recommendations">
              <div class="shop-recommendations-header" style="text-align: left; display: flex; align-items: center">
                <img :src="require('@/assets/img/mall/hot.png')" alt="精品推荐" style="width: 20px; height: 20px; margin-right: 10px" />
                <h4 style="margin: 0">精品推荐</h4>
              </div>
              <div class="recommendation-item" v-for="item in shopRecommendations" :key="item.id" @click="goToProduct(item.id)">
                <img :src="item.homeImg" :alt="item.name" />
                <div class="item-info">
                  <div class="item-name">{{ item.name }}</div>
                  <div class="item-brand" style="width: 100%; display: flex; justify-content: space-between; align-items: center">
                    <div class="item-price">¥{{ item.retailPrice }}</div>
                    <div class="item-sales">销量 {{ item.stockNum + 100 }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-layout></footer-layout>
  </div>
</template>

<script>
import FooterLayout from '@/components/pc/FooterLayout.vue'
import mall from '@/api/mall'

export default {
  name: 'MallProduct',
  components: { FooterLayout },
  data() {
    return {
      productId: '',
      currentImageIndex: 0,
      selectedSpec: 1,
      quantity: 1,
      activeTab: 'detail',
      category: {
        name: '',
        id: ''
      },
      shopInfo: {
        name: '高济药房',
        logo: require('@/assets/img/home/logo.png'),
        rating: 5,
        productCount: 128
      },
      product: {
        id: 1,
        name: '自粘性绷带',
        price: '8.90',
        originalPrice: '10.00',
        discount: true,
        rating: 5,
        sales: '0人评价',
        brand: '默认规格',
        stock: 999,
        hashMap: {},
        images: ['https://via.placeholder.com/400x400/FF6B6B/FFFFFF?text=主图1', 'https://via.placeholder.com/400x400/4ECDC4/FFFFFF?text=主图2', 'https://via.placeholder.com/400x400/45B7D1/FFFFFF?text=主图3', 'https://via.placeholder.com/400x400/96CEB4/FFFFFF?text=主图4'],
        specs: [{ id: 1, name: '1卷' }],
        detailImages: ['https://via.placeholder.com/800x600/FF6B6B/FFFFFF?text=详情图1', 'https://via.placeholder.com/800x600/4ECDC4/FFFFFF?text=详情图2'],
        params: [
          { name: '品牌', value: '默认品牌' },
          { name: '规格', value: '1卷' },
          { name: '材质', value: '医用材料' }
        ],
        reviewCount: 1250,
        goodRate: 98,
        shop: {
          id: 1,
          name: '陪诊三宝',
          logo: 'https://via.placeholder.com/80x80/409EFF/FFFFFF?text=店铺',
          rating: 5,
          productCount: 128
        }
      },
      shopRecommendations: []
    }
  },
  computed: {
    currentImage() {
      return this.product.imgList && this.product.imgList.length > 0 ? this.product.imgList[this.currentImageIndex] : ''
    }
  },
  methods: {
    getHotProduct() {
      let params = {
        pageNumber: 1, //页码
        pageSize: 5, //页大小
        channelCode: this.$local.get('channelCode')
      }
      mall.getHotProduct(params).then((res) => {
        this.shopRecommendations = res.data.data
      })
    },
    getProductDetail() {
      mall.getProductDetail({ id: this.$route.params.productId }).then((res) => {
        this.product = res.data.data
        console.log('商品详情', this.product)
      })
    },
    selectImage(index) {
      this.currentImageIndex = index
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    increaseQuantity() {
      if (this.quantity < this.product.stock) {
        this.quantity++
      }
    },
    addToCart() {
      // this.$message.success('已添加到购物车')
      this.$message.error('该商品已售罄，请及时关注库存')
    },
    addToast() {
      this.$message.success('已添加到到货通知')
    },
    goToShop() {
      this.$router.push(`/pc/mall/allProducts`)
    },
    goToProduct(productId) {
      this.$router.push({ path: `/pc/mall/product/${productId}`, query: { from: 'hot' } })
    },
    goToShopVerify() {
      this.$router.push('/pc/mall/shopVerify')
    }
  },
  mounted() {
    // 根据路由参数获取商品详情
    this.productId = this.$route.params.productId
    this.category = {
      name: this.$route.query.categoryName,
      id: this.$route.query.categoryId
    }
    this.getProductDetail(this.productId)
    this.getHotProduct()
  },
  watch: {
    $route(to, from) {
      if (to.params.productId !== from.params.productId) {
        this.productId = to.params.productId
        this.category = {
          name: to.query.categoryName,
          id: to.query.categoryId
        }
        this.getProductDetail(this.productId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.breadcrumb-section {
  background: #f8f9fa;
  padding: 10px 0;

  ::v-deep .el-breadcrumb {
    font-size: 14px;

    .el-breadcrumb__item__inner {
      color: #666;

      &:hover {
        color: #409eff;
      }
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #409eff;
    }
  }
}

.product-detail-section {
  padding: 30px 0;

  .product-main {
    display: flex;
    gap: 30px;
    margin-bottom: 40px;
    .product-info-container {
      display: flex;
      flex-direction: column;
      gap: 30px;
      flex: 3;
      .product-info-left {
        display: flex;
        justify-content: space-around;
      }
    }

    .product-images {
      width: 400px;
      flex-shrink: 0;

      .main-image {
        width: 100%;
        height: 400px;
        border: 1px solid #e5e5e5;
        margin-bottom: 10px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .thumb-images {
        display: flex;
        gap: 10px;

        .thumb-item {
          width: 60px;
          height: 56px;
          border: 2px solid transparent;
          cursor: pointer;

          &.active {
            border-color: #409eff;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    .product-info {
      width: 45%;

      h1 {
        font-size: 24px;
        color: #333;
        margin-bottom: 20px;
        line-height: 1.4;
      }

      .product-price-section {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .current-price {
          font-size: 28px;
          color: #e74c3c;
          font-weight: bold;
          margin-right: 15px;
        }

        .original-price {
          font-size: 16px;
          color: #999;
          text-decoration: line-through;
          margin-right: 10px;
        }

        .discount-tag {
          background: #e74c3c;
          color: white;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 12px;
        }
      }

      .product-rating {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .rating-stars {
          margin-right: 10px;

          i {
            &.el-icon-star-on {
              color: #ffa500;
            }

            &.el-icon-star-off {
              color: #ddd;
            }
          }
        }

        .rating-text {
          margin-right: 20px;
          color: #666;
        }

        .sales-count {
          color: #666;
        }
      }

      .product-specs {
        .spec-row {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 15px;

          .spec-label {
            text-align: left;
            flex: 1;
            width: 70px;
            color: #333;
            font-weight: bold;
          }
          .spec-value {
            text-align: left;
            flex: 2;
          }

          .spec-options {
            flex: 2;
            display: flex;
            gap: 10px;

            .spec-option {
              padding: 8px 0;
              border: 1px solid #ddd;
              border-radius: 4px;
              cursor: pointer;

              &:hover {
                border-color: #409eff;
              }

              &.active {
                border-color: #409eff;
                background: #409eff;
                color: white;
              }
            }
          }

          .quantity-control {
            flex: 2;
            display: flex;
            align-items: center;
            gap: 10px;

            .stock-info {
              color: #666;
              font-size: 14px;
            }
          }
        }
      }

      .action-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 30px 0;

        .el-button {
          margin-right: 15px;
          min-width: 120px;
        }
      }

      .service-info {
        .service-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          color: #666;

          i {
            margin-right: 8px;
            color: #409eff;
          }
        }
      }
    }

    .shop-info {
      width: 240px;
      flex-shrink: 0;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      padding: 20px;
      height: fit-content;

      .shop-header {
        display: flex;
        padding-bottom: 15px;
        border-bottom: 1px dashed #e5e5e5;

        .shop-logo {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 15px;
        }

        .shop-details {
          flex: 1;
          max-width: 150px;
          text-align: left;
          h3 {
            margin: 0 0 5px 0;
            color: #333;
            font-weight: bold;
          }

          .shop-rating {
            margin-bottom: 5px;

            .rating-stars {
              margin-right: 5px;

              i {
                font-size: 12px;

                &.el-icon-star-on {
                  color: #ffa500;
                }

                &.el-icon-star-off {
                  color: #ddd;
                }
              }
            }
          }

          .shop-stats {
            margin-top: 10px;
            font-size: 14px;
            color: #666;
          }
        }
      }

      .shop-actions {
        display: flex;
        justify-content: space-evenly;
        margin: 20px 0;

        .el-button {
          width: 100px;
          margin-bottom: 10px;
        }
      }
    }

    .shop-recommendations {
      margin-top: 20px;
      h4 {
        margin-bottom: 15px;
        color: #333;
      }

      .recommendation-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 15px;
        cursor: pointer;
        border-bottom: 1px dashed #e5e5e5;
        padding-bottom: 20px;
        &:last-child {
          border-bottom: none;
        }
        img {
          width: 200px;
          height: 200px;
          margin-right: 10px;
          border-radius: 4px;
        }

        .item-info {
          flex: 1;
          text-align: left;
          width: 200px;

          .item-name {
            margin-top: 10px;
            font-size: 14px;
            color: #333;
            margin-bottom: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .item-price {
            color: #e74c3c;
            font-weight: bold;
            font-size: 14px;
          }

          .item-sales {
            font-size: 12px;
            color: #666;
          }
        }
      }
    }
  }

  .product-detail-tabs {
    margin-top: 30px;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;

    .tab-headers {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      background: #f8f9fa;

      .tab-header {
        padding: 20px 40px;
        font-size: 16px;
        cursor: pointer;
        position: relative;
        transition: all 0.3s;
        color: #666;

        &:hover {
          color: #409eff;
        }

        &.active {
          color: #409eff;
          font-weight: bold;

          &:after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 100%;
            height: 2px;
            background: #409eff;
          }
        }
      }
    }

    .tab-content {
      padding: 20px;
      min-height: 300px;

      .detail-content {
        text-align: center;

        img {
          max-width: 100%;
          margin-bottom: 20px;
          display: block;
          margin: 0 auto 20px;
        }

        .no-detail {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px 0;
          min-height: 300px;
        }
      }

      .params-content {
        .params-table {
          width: 100%;
          border-collapse: collapse;

          tr {
            border-bottom: 1px solid #f0f0f0;

            td {
              padding: 15px;
              line-height: 1.5;

              &.param-name {
                background: #f8f9fa;
                width: 200px;
                font-weight: bold;
              }
            }
          }
        }
      }

      .reviews-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .review-summary {
          display: flex;
          gap: 50px;
          padding: 30px;
          background: #f8f9fa;
          border-radius: 4px;
          margin-bottom: 20px;

          .summary-rating {
            text-align: center;

            .big-rating {
              font-size: 48px;
              color: #e74c3c;
              font-weight: bold;
              display: block;
              margin-bottom: 10px;
            }

            .rating-stars {
              i {
                font-size: 16px;
                color: #ffa500;
              }
            }
          }

          .summary-stats {
            div {
              margin-bottom: 10px;
              color: #666;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

.product-detail-info {
  padding: 20px;

  .info-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    overflow: hidden;

    .card-title {
      text-align: center;
      font-size: 18px;
      color: #333;
      margin: 0;
      padding: 20px;
      background: #f8f9fa;
      border-bottom: 1px solid #eee;
    }

    .info-list {
      padding: 20px;

      .info-item {
        display: flex;
        margin-bottom: 15px;
        line-height: 24px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          width: 120px;
          color: #666;
          font-size: 14px;
          flex-shrink: 0;
        }

        .content {
          color: #333;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
